webpackJsonp([38121086484501],{

/***/ 1536:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProvidersOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"email","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"familyName","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"givenName","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-providers-order-by-be4e7d982e3b72bb11a1.js